import { t } from 'i18next';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import useLogin from '~hooks/useLogin/useLogin';

import SignUpResetForm from './SignUpResetForm';
import { ResetSignupProps } from './types';

const tokenUrl = 'token';

const SignUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { signUp } = useLogin();
  const [searchParams] = useSearchParams();
  const token = searchParams.get(tokenUrl)!;

  const handleSubmitSignUp = async (data: ResetSignupProps) => {
    setIsLoading(true);
    try {
      await signUp({ magic_links_token: token, password: data.password });
    } catch {
      // Errors are handled in useLogin.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SignUpResetForm
      formTitle={t('actions.signUp')}
      callBackAction={handleSubmitSignUp}
      isLoading={isLoading}
    />
  );
};
export default SignUp;
